export const diagnosisOptions: Array<string> =
  'Select a diagnosis, Cognitive Normal, Suspected Cognitive Decline, Mild Cognitive Impairment, Mild AD, Frontotemporal Dementia, Lewy Body Dementia, Vascular Dementia, Parkinson’s Disease, Other'.split(
    ','
  );
